import axios from 'axios';
import Forms from '../common/forms';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';

export default class ContactForm {

    constructor() {
        this.section = document.querySelector('.block-fale-conosco')
        this.anchor = document.querySelector('body')
        this.form = document.querySelector('#contact-form');
        this.formFields = this.form.querySelectorAll('input, select, textarea')
		this.successMessage = this.section.querySelector('.block-fale-conosco .success-form')
		this.errorMessage = this.section.querySelector('.block-fale-conosco .error-form')
        this.errorSubmitMessage = this.section.querySelector('.block-fale-conosco .error-submit-form')
        this.btnSubmit = this.form.querySelector('button');

        this.state = this.form.querySelector('#estado');     // ajuste o seletor conforme necessário
        this.cityInput = this.form.querySelector('#cidade');  // ajuste o seletor conforme necessário

        new Forms();

        this.ready();
        this.bindEvents();
        this.initRecaptcha();
    }

    ready() {
        
        new Bouncer(`#contact-form`, {
            ...Forms.config(),
            messages: Forms.messages(),
        });


        this.form.addEventListener('bouncerShowError', () => {
            this.errorMessage.classList.remove('hidden')
        }, false);
        
        this.form.addEventListener('bouncerFormInvalid', () => {
            Forms.activeErros(this.form);
        }, false);

        this.form.addEventListener(
            'bouncerFormValid',
            (event) => {
                event.preventDefault();
                if (event.target.id == this.form.id) {
                    this.sendForm(event.target);
                    // console.log('Formulário validado e pronto para ser enviado via AJAX.');
                }
            },
            false
        );
    }

    initRecaptcha() {
        this.formFields.forEach(field => {
            field.addEventListener('focus', () => {
                if (!window.grecaptcha) {
                    window.loadRecaptchaV3();
                }
            })
        })
    }

    bindEvents() {
        this.state.addEventListener('change', () => this.onStateChange());
        this.state.addEventListener('blur', () => this.onStateBlur());

        this.form.querySelector('select[name="assunto"]')
            .addEventListener('change', (e) => this.toggleSubject(e));

        this.form.querySelector('#anexos')
            .addEventListener('change', (e) => this.updateFilenameLabel(e));

        this.form.querySelector('#cpf').addEventListener('blur', (e) => this.validateCpfField(e));
    }

    validateCpfField(e) {
        console.log(e)
        const input = e.target;
        console.log(input)
        const container = input.closest('.contact-subject');
        const errorMessage = container ? container.querySelector('.error-message') : null;

        if (!input.hasAttribute('required')) {
            if (errorMessage) errorMessage.classList.add('hidden');
            return;
        }

        const cpf = input.value.replace(/\D/g, '');
        if (cpf && !this.isValidCpf(cpf)) {
            if (errorMessage) errorMessage.classList.remove('hidden');
        } else {
            if (errorMessage) errorMessage.classList.add('hidden');
        }
    }


    isValidCpf(cpf) {
        if (!cpf || cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

        let sum = 0, rest;

        for (let i = 1; i <= 9; i++) {
            sum += parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
        }
        rest = (sum * 10) % 11;
        if (rest === 10 || rest === 11) rest = 0;
        if (rest !== parseInt(cpf.substring(9, 10), 10)) return false;

        sum = 0;
        for (let i = 1; i <= 10; i++) {
            sum += parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
        }
        rest = (sum * 10) % 11;
        if (rest === 10 || rest === 11) rest = 0;
        if (rest !== parseInt(cpf.substring(10, 11), 10)) return false;

        return true;
    }

    toggleSubject(e) {
        const value = e.target.value;

        document.querySelectorAll('.contact-subject').forEach(el => {
            el.classList.add('hidden');
        });

        const targets = document.querySelectorAll(`.contact-subject-${value}`);
        targets.forEach(el => el.classList.remove('hidden'));

        if(value === '0060') {
            this.form.querySelector('#cpf').setAttribute('required', 'required');
            this.form.querySelector('#cep').setAttribute('required', 'required');
            this.form.querySelector('#endereco').setAttribute('required', 'required');
            this.form.querySelector('#numero').setAttribute('required', 'required');
            this.form.querySelector('#complemento').setAttribute('required', 'required');
            this.form.querySelector('#bairro').setAttribute('required', 'required');
            this.form.querySelector('#pais').setAttribute('required', 'required');
            this.form.querySelector('#produto').setAttribute('required', 'required');
            this.form.querySelector('#lote').setAttribute('required', 'required');
            this.form.querySelector('#validade').setAttribute('required', 'required');
        } else {
            this.form.querySelector('#cpf').removeAttribute('required');
            this.form.querySelector('#cep').removeAttribute('required');
            this.form.querySelector('#endereco').removeAttribute('required');
            this.form.querySelector('#numero').removeAttribute('required');
            this.form.querySelector('#complemento').removeAttribute('required');
            this.form.querySelector('#bairro').removeAttribute('required');
            this.form.querySelector('#pais').removeAttribute('required');
            this.form.querySelector('#produto').removeAttribute('required');
            this.form.querySelector('#lote').removeAttribute('required');
            this.form.querySelector('#validade').removeAttribute('required');
        }

    }

    updateFilenameLabel(e) {
        const files = Array.from(e.target.files);
        const filenames = files.map(file => file.name);

        const label = e.target.parentElement.querySelector('.filename');
        if (label) {
            label.innerHTML = filenames.join(', ');
        }
    }

    onStateBlur() {
        const returnState = this.state.value;
        const cityWrapper = this.cityInput.closest('.form-group') || this.cityInput.closest('.input-group');

        if (!returnState) {
            if (this.cityInput.tagName.toLowerCase() === 'select') {
                this.cityInput.innerHTML = '';
            } else {
                this.cityInput.value = '';
            }
            if (cityWrapper) cityWrapper.classList.add('hidden');
        }
    }

    async onStateChange() {
        const returnState = this.state.value;
        const cityWrapper = this.cityInput.closest('.form-group') || this.cityInput.closest('.input-group');

        if (!returnState) {
            if (this.cityInput.tagName.toLowerCase() === 'select') {
                this.cityInput.innerHTML = '';
            } else {
                this.cityInput.value = '';
            }
            if (cityWrapper) cityWrapper.classList.add('hidden');
            return;
        }

        if (cityWrapper) cityWrapper.classList.remove('hidden');

        try {
            const response = await axios.get(`https://brasilapi.com.br/api/ibge/municipios/v1/${returnState}`, {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            });

            const cidades = response.data.map(cidade => {
                return `<option value="${cidade.nome}">${cidade.nome}</option>`;
            }).join('');

            if (this.cityInput.tagName.toLowerCase() === 'select') {
                this.cityInput.innerHTML = cidades;
            } else {
                this.cityInput.value = '';
            }
        } catch (error) {
            console.error('Erro ao buscar cidades:', error);
        }
    }

    sendForm(form) {
        reloadCaptcha('contact', 'g-recaptcha-response', () => {
            this.errorSubmitMessage.classList.add('hidden');
            this.successMessage.classList.add('hidden');
            this.errorMessage.classList.add('hidden');

            this.btnSubmit.disabled = true;
            this.btnSubmit.classList.add('loading');

            const rawFormData = new FormData(form);

            rawFormData.set('age', form.querySelector('#checkage').checked ? 1 : 0);
            rawFormData.set('data', form.querySelector('#checkdata').checked ? 1 : 0);
            rawFormData.set('optin', form.querySelector('#checkoptin').checked ? 1 : 0);

            const maskedPlaceholders = ['__/__/____', '(__) ____-____', '____-__'];

            const filteredFormData = new FormData();
            for (let [key, value] of rawFormData.entries()) {
                if (typeof value === 'string'
                    ? value.trim() !== '' && !maskedPlaceholders.includes(value)
                    : true) {
                    filteredFormData.append(key, value);
                }
            }

            const urlForm = form.getAttribute('data-action');

            axios.post(urlForm, filteredFormData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            .then((response) => {
                const { success, message } = response.data;

                if (success) {
                    form.reset();
                    if (this.cityInput.tagName.toLowerCase() === 'select') {
                        this.cityInput.innerHTML = '<option value="" disabled selected>Cidade</option>';
                    }
                    this.successMessage.textContent = message;
                    this.successMessage.classList.remove('hidden');

                    setTimeout(() => {
                        this.successMessage.classList.add('hidden');
                    }, 5000);
                } else {
                    this.errorSubmitMessage.textContent = message || 'Erro ao enviar formulário.';
                    this.errorSubmitMessage.classList.remove('hidden');
                }
            })
            .catch(() => {
                this.errorSubmitMessage.textContent = 'Erro ao enviar formulário.';
                this.errorSubmitMessage.classList.remove('hidden');
            })
            .finally(() => {
                this.btnSubmit.disabled = false;
                this.btnSubmit.classList.remove('loading');
            });
        });
    }



}


if(document.querySelector('.block-fale-conosco')) {
    new ContactForm()
}